import { connect } from "react-redux";
import { push } from "react-router-redux";

import Kompressorsteuerung from "./Kompressorsteuerung";

import { prevInstalledCompressorIndex, nextInstalledCompressorIndex,
	genChangeCompressorPath, defaultCompressorPath } from "../model/Kompressor";

export default connect(state => ({
	location_path: state.router.location.pathname,
	default_path: defaultCompressorPath(state, "/overview/compressor/"),
	previous_index: prevInstalledCompressorIndex(state.router.location.pathname, state.ablauf.compressors),
	next_index: nextInstalledCompressorIndex(state.router.location.pathname, state.ablauf.compressors)
}), dispatch => ({
	showAnlagenpass: location_path => {
		let parts = location_path.split("/");
		if (parts[parts.length - 1] === "type_plate") {
			parts.splice(parts.length - 1, 1);
		} else {
			parts.push("type_plate");
		}
		dispatch(push(parts.join("/")));
	},
	gotoCompressor: genChangeCompressorPath(dispatch)
}))(Kompressorsteuerung);
